export const DELAYS = {
  MEETING_REDIRECT: 1000,
} as const;

export const UI_TEXT = {
  SUCCESS: 'You have been logged in successfully.',
  LOADING: 'Loading...',
  FAILED_FALLBACK: 'Failed to authenticate. Please try again.',
  REDIRECTING_PREFIX: 'Redirecting you back to your',
  REDIRECTING_SUFFIX: 'meeting...',
  CLOSE_MESSAGE:
    'If this page does not dismiss automatically, you may close it and return to your meeting.',
  COPYRIGHT: '© 2026 Pindrop Security. All rights reserved.',
  TERMS_TEXT: 'Terms of Use',
  POLICY_TEXT: 'Audio & Data Use Policy',
} as const;
